import type { RecipientFrameDraft } from './useRecipientFrameDraft';
import { useTranslation } from 'react-i18next';
import { AvatarFramePicker } from '@src/components/faces/AvatarFramePicker';
import { Switch } from '@src/components/Switch/Switch';
import { useAppSelector } from '@src/state/hooks';
import { trackGiftEvent } from '@src/utils/giftAnalytics';

/** Applying a frame is optional and independent of sending a thank-you. */
export function ReceivedBoxGiftFrame({ draft }: { draft: RecipientFrameDraft }) {
  const { t } = useTranslation();
  const card = useAppSelector(
    (state) => state.box.card ?? state.box.cards.find((item) => item.isYou),
  );
  const { frame, enabled, select } = draft;
  return (
    <section className="box-gift-dialog__frame-reward" data-testid="random-gift-recipient-frame">
      <h3>{t('boxGift.recipientFramesTitle')}</h3>
      <p>{t('boxGift.recipientFramesDescription')}</p>
      <fieldset
        className="box-gift-dialog__recipient-frames random-gift-frames"
      >
        <AvatarFramePicker
          card={card}
          index={card?.id}
          selectedFrame={frame}
          onChange={(name) => {
            trackGiftEvent('santa_gift_received_frame_clicked');
            select(name, true);
          }}
          testIdPrefix="random-gift-recipient-frame"
        />
        <Switch
          className="box-gift-dialog__frame-toggle"
          checked={enabled}
          onCheckedChange={(value) => select(frame, value)}
          label={t('boxGift.decorateAvatar')}
          testId="random-gift-recipient-frame-toggle"
        />
      </fieldset>
    </section>
  );
}
